import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../../components/ui/select";

export default function Paginacao({ total, pagina, porPagina, onPagina, onPorPagina }) {
  const totalPaginas = Math.max(1, Math.ceil(total / porPagina));
  const inicio = (pagina - 1) * porPagina;
  const fim = Math.min(inicio + porPagina, total);
  return (
    <div className="flex items-center justify-between flex-wrap gap-3 px-5 py-2.5 border-t bg-muted/20">
      <div className="flex items-center gap-2 text-xs">
        <span className="text-muted-foreground">Mostrar</span>
        <Select value={String(porPagina)} onValueChange={(v) => onPorPagina(parseInt(v, 10))}>
          <SelectTrigger className="w-[72px] h-8 text-xs"><SelectValue /></SelectTrigger>
          <SelectContent>
            {[5, 10, 15, 20].map((n) => <SelectItem key={n} value={String(n)}>{n}</SelectItem>)}
          </SelectContent>
        </Select>
        <span className="text-muted-foreground">por página</span>
      </div>
      <span className="text-xs text-muted-foreground tabular-nums">{inicio + 1}–{fim} de {total}</span>
      <div className="flex items-center gap-1">
        <Button size="sm" variant="outline" className="h-8 w-8 p-0" onClick={() => onPagina(pagina - 1)} disabled={pagina <= 1} aria-label="Página anterior">
          <ChevronLeft className="w-4 h-4" />
        </Button>
        <span className="text-xs font-medium px-3 tabular-nums whitespace-nowrap">Página {pagina} de {totalPaginas}</span>
        <Button size="sm" variant="outline" className="h-8 w-8 p-0" onClick={() => onPagina(pagina + 1)} disabled={pagina >= totalPaginas} aria-label="Próxima página">
          <ChevronRight className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}
